module.exports = __webpack_public_path__ + "00_glasses.1f63cd58.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer4/00_glasses.png
// module id = zSWd
// module chunks = 0